import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'rimuoviduplicati'
})

export class RimuoviDuplicatiPipe implements PipeTransform {
    /**
     * controllo in una lista di stringhe se vi sono duplicati splittati per ; 
     * e salvo solo gli oggetti in singola copia
     * @param  {string} value
     */
    transform(value: string): any[] {
        var out = [];
        if (value.length > 0){
            var tmp = value.split(';');
            var work =  tmp.filter(Boolean);
            for(var i = 0; i < work.length; i++) {
                var controllo = work[i];
                if (out.indexOf(controllo) == -1) 
                    out.push(controllo); 
            }
        }  
        return out;
    }
}